<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-mfc">
    <div class="tpl-mfc__backdrop">
      <header class="tpl-mfc__ghost-header">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-mfc__logo" />
      </header>
      <p v-if="quiz.title" class="tpl-mfc__ghost-line">{{ quiz.title }}</p>
      <p v-if="quiz.sub_title" class="tpl-mfc__ghost-line tpl-mfc__ghost-line--sub">{{ quiz.sub_title }}</p>
    </div>

    <div class="tpl-mfc__overlay">
      <div class="tpl-mfc__modal">
        <slot />
      </div>
      <footer class="tpl-mfc__footer">
        <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
          {{ quiz.privacy_text || 'Privacy Policy' }}
        </a>
        <p v-if="quiz.legal_name" class="tpl-mfc__footer-legal">
          {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-mfc__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </div>
  </div>
</template>
